import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { Observable } from 'rxjs';
import { ApiProviderService } from 'src/app/services/api-provider.service';

@Injectable({
  providedIn: 'root'
})
export class AddressInfoService {

  headers: HttpHeaders;
  apiServer: string;

  constructor(private http: HttpClient, private apiRef: ApiProviderService) {
    this.headers = new HttpHeaders();
    this.headers.append('Content-Type', 'application/json');
    this.headers.append('Accept', 'application/json');
    this.apiServer = 'api/Address/';
  }

  getAddressTypes(contactType: string) {
    return this.http.get(this.apiRef.getApiUrl(`${this.apiServer}getAddressTypes`, [{Key: 'contactType', Value: contactType}]));
  }

  getStreetDirectionValues() {
    return this.http.get(this.apiRef.getApiUrl(`${this.apiServer}getStreetDirectionValues`));
  }

  getStreetSuffixValues() {
    return this.http.get(this.apiRef.getApiUrl(`${this.apiServer}getStreetSuffixValues`));
  }

  getStreetTypeValues() {
    return this.http.get(this.apiRef.getApiUrl(`${this.apiServer}getStreetTypeValues`));
  }

  getUnitTypes() {
    return this.http.get(this.apiRef.getApiUrl(`${this.apiServer}getUnitTypes`));
  }

  getSubdivisionValues(showType) {
    return this.http.get(this.apiRef.getApiUrl(`${this.apiServer}getSubdivisionValues`, [{ Key: 'showType', Value: showType }]));
  }
}
